import { type ReactElement } from "react";
import { Text, Box, Alert } from "@citibox-panel/ui";
import { Section } from "./DemoScaffold";
import { SearchShellDemo } from "./SearchShellDemo";
import { TextDemo } from "./TextDemo";
import { ButtonDemo } from "./ButtonDemo";
import { LayoutDemo } from "./LayoutDemo";
import { CardDemo } from "./CardDemo";
import { AlertDemo } from "./AlertDemo";
import { ChipDemo } from "./ChipDemo";
import { TableDemo } from "./TableDemo";
import { SkeletonDemo } from "./SkeletonDemo";
import { LinearProgressDemo } from "./LinearProgressDemo";
import { AvatarDemo } from "./AvatarDemo";
import { TextFieldDemo } from "./TextFieldDemo";
import { CodeDemo } from "./CodeDemo";
import { DividerDemo } from "./DividerDemo";
import { EmptyStateDemo } from "./EmptyStateDemo";
import { ErrorBoundaryDemo } from "./ErrorBoundaryDemo";
import { MenuDemo } from "./MenuDemo";
import { TabsDemo } from "./TabsDemo";
import { LogoDemo } from "./LogoDemo";

// TODO: i18n — copy en ES hasta Fase 1.

// The living catalog of the @citibox-panel/ui façade. Thin composition root: the
// search shell (full-bleed, at the top) + the info label, then one <Section> per
// façade component, each delegating to its own colocated <XDemo/> file.
export function UiKitPage(): ReactElement {
  return (
    <>
      {/* Search shell — full-bleed at the very top, mirroring the live app header
          (the brand search bar is the first thing an agent sees). */}
      <Box component="section" sx={{ width: "100%" }}>
        {/* No fixed height / overflow here: SearchShell is minHeight:100vh, so a
            bounded box would nest a second scrollbar inside the page scroll.
            Letting it size naturally keeps a single (page) scroll. */}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <SearchShellDemo />
        </Box>
        <Box sx={{ maxWidth: 960, mx: "auto", px: 4, py: 2 }}>
          {/* TODO: i18n — título + cómo probar el componente, en una etiqueta informativa. */}
          <Alert severity="info">
            <strong>Search shell</strong> — el shell search-first (
            <code>apps/lockers/care</code>) con la búsqueda por teléfono real
            (sobre el mock). Para probarlo: escribe un teléfono (p. ej. 612 348
            902 → 1 usuario; 678 221 540 → 2) y pulsa Enter; &ldquo;+&rdquo; /
            ⌘K / la acción del estado vacío enfocan el buscador.
          </Alert>
        </Box>
      </Box>
      <main style={{ maxWidth: 960, margin: "0 auto", padding: 32 }}>
        <Text variant="h3" component="h1" gutterBottom>
          Citibox Panel — UI Kit
        </Text>
        <Text variant="body1" color="secondary">
          Catálogo vivo de los componentes de la fachada{" "}
          <code>@citibox-panel/ui</code>. Tema MUI Material por defecto.
        </Text>

        <div style={{ height: 32 }} />

        <Section title="Text">
          <TextDemo />
        </Section>
        <Section title="Code">
          <CodeDemo />
        </Section>
        <Section title="Button">
          <ButtonDemo />
        </Section>
        <Section title="Layout (Box & Stack)">
          <LayoutDemo />
        </Section>
        <Section title="Card">
          <CardDemo />
        </Section>
        <Section title="Alert">
          <AlertDemo />
        </Section>
        <Section title="Chip">
          <ChipDemo />
        </Section>
        <Section title="Table">
          <TableDemo />
        </Section>
        <Section title="Skeleton">
          <SkeletonDemo />
        </Section>
        <Section title="LinearProgress">
          <LinearProgressDemo />
        </Section>
        <Section title="Avatar">
          <AvatarDemo />
        </Section>
        <Section title="TextField">
          <TextFieldDemo />
        </Section>
        <Section title="Divider">
          <DividerDemo />
        </Section>
        <Section title="Empty state">
          <EmptyStateDemo />
        </Section>
        <Section title="Feature error boundary">
          <ErrorBoundaryDemo />
        </Section>
        <Section title="Icon button & Menu">
          <MenuDemo />
        </Section>
        <Section title="Tabs">
          <TabsDemo />
        </Section>
        <Section title="Logo">
          <LogoDemo />
        </Section>
      </main>
    </>
  );
}
